import makeService from './api';

export default makeService('updated_lynxapis');
